import { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/TextNew';

export default function SectionHeader({
  title,
  description,
  maxWidthTitle = '939px',
  maxWidthDescription = '848px',
  bottomMarginClassName = 'mb-10 lg:mb-18',
  children,
  headingLevel = 'h2',
}: {
  title: string;
  description?: string;
  maxWidthTitle?: string;
  maxWidthDescription?: string;
  bottomMarginClassName?: string;
  children?: ReactNode;
  headingLevel?: 'h1' | 'h2';
}) {
  return (
    <div className={`${bottomMarginClassName} flex flex-col gap-8`}>
      <Text
        as={headingLevel}
        token={{ base: 'display/32/bold', lg: 'display/64/bold' }}
        style={{ maxWidth: maxWidthTitle }}
      >
        {title}
      </Text>
      {description && (
        <Text
          as="p"
          token={{ base: 'sans/16/medium', lg: 'sans/24/medium' }}
          style={{ maxWidth: maxWidthDescription }}
        >
          {description}
        </Text>
      )}
      <div className="cw-text-box-none">{children}</div>
    </div>
  );
}
